import { render, staticRenderFns } from "./UbahUser.vue?vue&type=template&id=c310e91a"
import script from "./UbahUser.vue?vue&type=script&lang=js"
export * from "./UbahUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports